import { Theme } from "@mui/material/styles";
import { useTheme } from "@mui/styles";
import classNames from "classnames";
import { iconHoverBorderStyle } from "ds_legacy/materials/layouts";
import { dp } from "ds_legacy/materials/metrics";
import { ChevronDownIcon, ChevronUpIcon } from "lucide-react";
import { DropdownIndicatorProps } from "react-select";
import { SelectOption } from "./types";

function getIconStyle({
  isDisabled,
  theme,
}: {
  isDisabled?: boolean;
  theme: Theme;
}) {
  return {
    ":hover": iconHoverBorderStyle(theme),
    borderRadius: dp(24),
    height: dp(16),
    opacity: isDisabled ? 0.25 : 0.8,
    width: dp(16),
  };
}

export function DropdownIndicator({
  isDisabled,
  selectProps: { classes, menuIsOpen },
}: DropdownIndicatorProps<SelectOption>) {
  const theme = useTheme();
  const iconStyle = getIconStyle({ isDisabled, theme });
  return (
    <div className={classNames(classes.dropdownIndicatorContainer)}>
      {menuIsOpen ? (
        <ChevronUpIcon style={{ color: "currentColor", ...iconStyle }} />
      ) : (
        <ChevronDownIcon
          style={{
            color: "currentColor",
            ...iconStyle,
            opacity: 0.5,
          }}
        />
      )}
    </div>
  );
}
